import React from "react";
import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/sections/HeroSection";
import FeaturesSection from "@/components/sections/FeaturesSection";
import HowItWorksSection from "@/components/sections/HowItWorksSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import CTASection from "@/components/sections/CTASection";

const HomePage = () => (
  <div data-testid="home-page">
    <SEOHead
      title="ApplyStrat | Strategic Tech Job Applications, Done for You"
      description="We apply to tech jobs on your behalf through official company portals. You focus on interview prep. For ML Engineers, AI Engineers, Software Engineers, and Cybersecurity professionals."
      canonical="https://applystrat.com/"
    />
    <HeroSection />
    <FeaturesSection />
    <HowItWorksSection />
    <TestimonialsSection />
    <CTASection />
  </div>
);

export default HomePage;
